module.exports = __webpack_public_path__ + "static/media/gallery_add_black.5ca42ce7.svg";